<template>
  <v-list dense>
    <template v-for="(item, i) in itemsToShow">
      <drawer-list-item :key="i" :item="item" :active="$route.path.startsWith(item.path)" @onNavigate="onNavigate(item)" />
    </template>
  </v-list>
</template>

<script>
import { mapActions } from 'vuex';
import AuthenticationService from '@/services/AuthenticationService';
import DrawerListItem from './DrawerListItem.vue';

export default {
  name: 'DrawerList',
  components: {
    'drawer-list-item': DrawerListItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    itemsToShow() {
      if (AuthenticationService.isAdmin()) {
        return this.items;
      }

      return this.items.filter(i => !i.admin);
    },
  },
  methods: {
    ...mapActions('drawerStore', ['navigate', 'toggleDrawer']),
    onNavigate(item) {
      this.navigate({
        path: item.path,
        day: null,
        provider: null,
      });

      if (this.$vuetify.breakpoint.smAndDown) {
        this.toggleDrawer(false);
      }
    },
  },
};
</script>
